var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckAssets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.25H12.2529C12.4364 5.25 12.5281 5.25 12.6144 5.27072C12.691 5.2891 12.7641 5.3194 12.8312 5.36052C12.9069 5.4069 12.9718 5.47176 13.1015 5.60147L16.1485 8.64853C16.2782 8.77824 16.3431 8.8431 16.3895 8.91879C16.4306 8.98589 16.4609 9.05905 16.4793 9.13558C16.5 9.22189 16.5 9.31361 16.5 9.49706V11.625C16.5 11.9745 16.5 12.1492 16.4429 12.287C16.3668 12.4708 16.2208 12.6168 16.037 12.6929C15.8992 12.75 15.7245 12.75 15.375 12.75M11.625 12.75H10.5M10.5 12.75V5.4C10.5 4.55992 10.5 4.13988 10.3365 3.81901C10.1927 3.53677 9.96323 3.3073 9.68099 3.16349C9.36012 3 8.94008 3 8.1 3H3.9C3.05992 3 2.63988 3 2.31901 3.16349C2.03677 3.3073 1.8073 3.53677 1.66349 3.81901C1.5 4.13988 1.5 4.55992 1.5 5.4V11.25C1.5 12.0784 2.17157 12.75 3 12.75M10.5 12.75H7.5M7.5 12.75C7.5 13.9926 6.49264 15 5.25 15C4.00736 15 3 13.9926 3 12.75M7.5 12.75C7.5 11.5074 6.49264 10.5 5.25 10.5C4.00736 10.5 3 11.5074 3 12.75M15.375 13.125C15.375 14.1605 14.5355 15 13.5 15C12.4645 15 11.625 14.1605 11.625 13.125C11.625 12.0895 12.4645 11.25 13.5 11.25C14.5355 11.25 15.375 12.0895 15.375 13.125Z",
    stroke: "#365A6D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckAssets);
export default __webpack_public_path__ + "static/media/truckAssets.7fe9da23ec7fabb100a1addbf3510858.svg";
export { ForwardRef as ReactComponent };